<div class="map" (window:resize)="setSize()" id="{{target}}"></div>